<template>
  <el-container class="myContainer">
    <el-aside width="320px" class="myContainer">
      <el-card class="box-card">
        <div v-if="this.currentCatalog.id != 'ROOT' || this.isShow == true" class="card-header">
          <div v-for="item in folderButton" :key="item.id" class="folderButton">
            <FrameButton :key="item.id" :button="item" :parentData="currentCatalog" circle @reSearch="loadDirTree"></FrameButton>
          </div>
        </div>
        <el-tree :data="catalogData" :props="defaultProps" node-key="id"
                 @node-click="nodeClickHandle"
                 default-expand-all highlight-current ref="active"
                 :expand-on-click-node="false" class="department-tree">

          <template #default="{ node, data }">
            <span class="custom-tree-node">
              <span>{{ node.label }}</span>
              <span v-if="data.code != null">({{ data.code }})</span>
            </span>

<!--            <el-row style="width:100%" :gutter="20">-->
<!--              <el-col :span="16" style="line-height: 32px">{{ node.label }}</el-col>-->

<!--              &lt;!&ndash;              <el-col :span="2" justify="end" v-show="currentCatalog.id == data.id" style="line-height: 32px;vertical-align: middle">&ndash;&gt;-->
<!--              &lt;!&ndash;                <FrameButton v-if="data.level < 7" :key="data.id" :button="addButton" :parentData="data" @reSearch="loadDirTree"></FrameButton>&ndash;&gt;-->
<!--              &lt;!&ndash;              </el-col>&ndash;&gt;-->
<!--              &lt;!&ndash;              <el-col :span="2" justify="end" v-show="currentCatalog.id == data.id" style="line-height: 32px;vertical-align: middle">&ndash;&gt;-->
<!--              &lt;!&ndash;                <FrameButton :key="data.id" :button="editButton" :parentData="data" @reSearch="loadDirTree"></FrameButton>&ndash;&gt;-->
<!--              &lt;!&ndash;              </el-col>&ndash;&gt;-->
<!--              &lt;!&ndash;              <el-col :span="2" justify="end" v-show="currentCatalog.id == data.id" style="line-height: 32px;vertical-align: middle">&ndash;&gt;-->
<!--              &lt;!&ndash;                <FrameButton v-if="data.level == 0" :key="data.id" :button="impButton" ></FrameButton>&ndash;&gt;-->
<!--              &lt;!&ndash;              </el-col>&ndash;&gt;-->

<!--            </el-row>-->
          </template>

        </el-tree>

      </el-card>

    </el-aside>

    <el-main class="myContainer">

      <el-card class="box-card">
        <template #header>
          <div class="card-header">
            <span width="100%" class="department-name">备品目录：{{ currentCatalog.name }}</span>
          </div>
        </template>
        <div>
          <frame-query ref="frameQuery" componentParam="eq_material_zhizao_query" :parent-data="{catalog_id:currentCatalog.id}" style="height: 100%;"></frame-query>
        </div>
      </el-card>

    </el-main>

  </el-container>
</template>

<script>
import {useDateFormat} from "@vueuse/core";

export default {
  name: "EqMaterialCatalogZhiZao",
  components: {},
  data() {
    return {
      addButton:{
        "component": "button",
        "text":true,
        "circle": true,
        "icon_only": true,
        "icon": "el-icon-CirclePlus",
        "click": "jsOpenWindow",
        "window": {"component": "frame/FrameForm", "type": "eq_material_catalog_zhizao_add","title":"添加目录","width":800,"height":600}
      },
      editButton:{
        "component": "button",
        "text":true,
        "circle": true,
        "icon_only": true,
        "icon": "el-icon-Edit",
        "click": "jsOpenWindow",
        "window": {"component": "frame/FrameForm", "type": "eq_material_catalog_zhizao_edit","title":"编辑目录","width":800,"height":600}
      },
      // impButton:{
      //   "component": "button",
      //   "text":true,
      //   "circle": true,
      //   "icon_only": true,
      //   "icon": "el-icon-Grid",
      //   "action_type": "open_window",
      //   "window": {"component": "frame/FrameForm", "type": "eq_material_catalog_zhizao_import","title":"导入目录","width":800,"height":600}
      // },
      folderButton: [
        {
          "component": "button",
          "type": "text",
          "style": "font-size: 30px",
          "icon": "el-icon-folder-add",
          "click": "jsOpenWindow",
          "window": {"component": "frame/FrameForm", "type": "eq_material_catalog_zhizao_add","title":"添加目录","width":500,"height":300},
          "roles_white":[]
        },
        {
          "component": "button",
          "type": "text",
          "style": "font-size: 30px",
          "icon": "el-icon-edit",
          "click": "jsOpenWindow",
          "window": {"component": "frame/FrameForm", "type": "eq_material_catalog_zhizao_edit","title":"编辑目录","width":500,"height":300},
          "roles_white":[]
        },
        {
          "component": "button",
          "type": "text",
          "icon": "el-icon-delete",
          "style": "font-size: 30px",
          "click": "jsOpenWindow",
          "window": {"component": "frame/FrameForm", "type": "eq_material_catalog_zhizao_delete", "title": "删除目录", "width": 500, "height": 300},
          "roles_white":[]
        },
        // {
        //   "component": "button",
        //   "type": "text",
        //   "icon": "el-icon-setting",
        //   "style": "font-size: 30px",
        //   "click": "jsOpenWindow",
        //   "window": {"component": "frame/FrameForm", "type": "eq_material_catalog_zhizao_setting", "title": "目录设置", "width": 850, "height": 600, "icon": "system/tools"},
        //   "roles_white":[]
        // }
      ],
      addData: {parentId: '', name: ''},
      catalogData: [],
      materialData: [],
      currentCatalog: {},
      subPage: 'product',
      isShow: false,
      editData: {id: '', oldName: '', name: '',},
      defaultProps: {
        children: 'children',
        label: 'name',
      }
    }
  },
  methods: {
    //--勾选--
    //操作方式
    nodeClickHandle(currentRow) {
      this.currentCatalog = currentRow;
      this.$refs.frameQuery.search();
    },
    //获取数据信息
    async loadDirTree() {
      await this.$http('eqMaterialCatalogZhiZaoService.getRootTree', {}, false).then(data => {
        this.catalogData = data;
        //this.currentCatalog = this.catalogData[0]
      }, errMsg => {
        return this.$message.error(errMsg);
      })
    },

    //获取当前用户权限是否可以添加
    async getCurrentUserRole() {
      await this.$http('eqMaterialCatalogZhiZaoService.getCurrentUserRole',{}, false).then(data => {
        this.isShow = data;
      }, errMsg => {
        return this.$message.error(errMsg);
      })
    }
  },
  provide(){
    return {
      $fn: {
        reLoadDirTree: () => {
          this.loadDirTree();
        },
      }
    }
  },
  created() {
    this.loadDirTree();
    this.getCurrentUserRole()
  }
}
</script>

<style lang="less" scoped>
@import '@/global.less';

.myContainer {
  padding: 5px;
}

//.card-header {
//  display: flex;
//  justify-content: space-between;
//  align-items: center;
//}

.card-header {
  display: inline-flex;
  width: 100%;
  height: 44px;
  line-height: 44px;
  padding-top: 3px;
  //display: flex;
  //justify-content: space-between;
  //align-items: center;
}

.folderButton {
  display: inline-flex;
}

.department-name {
  font-size: @fontSizeXX;
}

.activeButton {
  background-color: #409EFF;
  color: #FFFFFF
}

.scroller::-webkit-scrollbar {
  width: 3px;
}

.scroller::-webkit-scrollbar-track {
  background-color: transparent;
}

.scroller::-webkit-scrollbar-thumb {
  background-color: #C1C1C1;
}

.departmentBody {
  border: #ececec solid 1px;
  font-weight: normal;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  padding: 0 1px 2px;
}

.departmentLeft {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  box-sizing: content-box;
}

.departmentRight {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: auto;
  width: 100%;
  min-width: 550px;
}

.treeIcon {
  margin-right: 10px
}

.LeftBody {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  padding-top: 10px;
  overflow-y: auto;
}

.flexRow {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.userRights {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 5px 5px 0 5px;
}

.departmentUserList {
  padding: 0 20px 10px;
  display: flex;
  flex-direction: column;
}

.departmentTitle {
  height: 45px !important;
  line-height: 40px;
  font-size: @fontSizeSS;
}

.departmentName {
  white-space: nowrap;
  min-width: 120px;
  margin-right: 30px;
  padding-right: 20px;
  font-size: @fontSizeS;
}

.titleFlex {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.departmentEdit {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 10px 0;
}

.departmentTable {
  border: none;
  width: 100%;
}

.flexRow > .el-menu-item {
  height: 50px;
  line-height: 50px;
}

.buttonGroup {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.addButton {
  margin-left: 5px !important;
  padding: 9px;
}

.addDepartment {
  width: 140px;
  margin-right: 5px;
}

.LeftBody ::v-deep(.el-tree-node__expand-icon) {
  width: 15px;
}

.buttonGroup ::v-deep(.el-icon-key) {
  transform: rotate(180deg);
}

.editButton {
  color: lightgrey;
  min-height: 30px;
  padding: 0;
}

.editButton:hover {
  color: #00afff;
}
</style>
<style lang="less">
@import '@/global.less';

.rightTree > .el-tree-node > .el-tree-node__children {
  display: flex;
  flex-direction: row !important;
}

.rightTree > .el-tree-node > .el-tree-node__content {
  height: 40px;
}

.rightTree > .el-tree-node > .el-tree-node__content > .el-tree-node__label {
  font-size: @fontSizeS;
}

.departmentPoper {
  padding: 0 !important;
}

.poperItem {
  color: #409EFF;
  padding: 0 10px;
  height: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.poperItem:hover {
  background: whitesmoke;
}

.textDepartment {
  font-size: medium;
}
</style>

<style scoped>
.el-tree >>> .el-tree-node__content {
  height: 36px;
}

.department-tree{
  min-height: 600px;
  overflow-y: auto;
}
</style>